import './Sass/App.scss';
import React, {Suspense, useContext, useState} from 'react'
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";

import {getSessionCookie, isLoggedIn, SessionContext, setSessionCookie,} from './Utils/sessions';
import {createBrowserHistory} from "history";
import useDeepCompareEffect from 'use-deep-compare-effect'
import Spinner from 'react-bootstrap/Spinner'
import MainDashboard from "./Pages/MainDashboard";
import {AdminApi} from "./Api/AdminApi";
import Login from "./Pages/Login";
import UserDashboard from "./Pages/UserDashboard";
import ScheduleDashboard from "./Pages/ScheduleDashboard";
import NotificationDashboard from "./Pages/NotificationDashboard";
import MediaDashboard from "./Pages/MediaDashboard";
import PaymentsDashboard from "./Pages/PaymentsDashboard";
import SupportDashboard from "./Pages/SupportDashboard";
import GrowthDashboard from "./Pages/GrowthDashboard";
import {validateSessionToken} from "./Api/Utils/auth";
import MessagingDashboard from "./Pages/MessagingDashboard";

const history = createBrowserHistory();

const renderLoader = () => <div style={{position:'absolute', top:0, bottom:0, left:0, right: 0, backgroundColor:'dodgerblue', display:'flex', alignItems:'center', justifyContent:'center'}}>
    <Spinner style={{color:"white"}} animation="border" role="status"></Spinner>
</div>;

const AuthenticationRoute = ({ component: ChildComponent, ...props }) => {
  const {session} = useContext(SessionContext);

  return (
      <Route
          {...props}
          render={(props) => {
            if (isLoggedIn(session)) {
              return <Redirect to='/dashboard'/>
            } else {
              return <Suspense fallback={renderLoader()}>
                <ChildComponent {...props} />
              </Suspense>
            }
          }}
      />
  );
}

const AdminRoute = ({ component: ChildComponent, ...props }) => {
  const {session} = useContext(SessionContext);
  return <Route {...props} render={() => {
    if (!isLoggedIn(session)) {
      localStorage.setItem('prevLocation', window.location);
      return <Redirect to='/login'/>
    } else {
      return <Suspense fallback={renderLoader()}>
        <ChildComponent {...props} />
      </Suspense>
    }
  }} />
}

function App() {
  const [session, setSession] = useState(getSessionCookie());
  const refreshSession = () => {
    if (session === undefined || session === {}) {

    } else {

    }
  };


  if (session.jwt) {
    AdminApi.Auth.validateSessionToken(session.jwt).catch(() => {
      setSessionCookie({})
      return <Redirect to='/login'/>
    })
  }

  const value = {session, refreshSession};
  useDeepCompareEffect(
    () => {
      setSession(getSessionCookie());
    },
    [session]
  );

  return (
    <SessionContext.Provider value={value}>
      <Router history={history}>
        <Switch>
          <AdminRoute exact path="/dashboard" component={MainDashboard}/>
          <AdminRoute exact path="/users" component={UserDashboard}/>
          <AdminRoute exact path="/growth" component={GrowthDashboard}/>
          <AdminRoute exact path="/schedule" component={ScheduleDashboard}/>
          <AdminRoute exact path="/notifications" component={NotificationDashboard}/>
          <AdminRoute exact path="/media" component={MediaDashboard}/>
          <AdminRoute exact path="/payments" component={PaymentsDashboard}/>
          <AdminRoute exact path="/support" component={SupportDashboard}/>
          <AdminRoute exact path="/inbox" component={MessagingDashboard}/>
          <AuthenticationRoute exact path="/login" component={Login}/>

          {/*Place these at the end as fallbacks for unsupported paths*/}
          <AdminRoute exact path="/*" component={MainDashboard}/>
          <AuthenticationRoute exact path="/*" component={Login}/>
        </Switch>
      </Router>
    </SessionContext.Provider>
  );
}

export default App;
